export const APP_REDUCER = 'app';
export const I18N_REDUCER = 'i18n';
export const AUTH_REDUCER = 'auth';
export const USER_REDUCER = 'user';
export const SOCKET_REDUCER = 'socket';
export const PAGE_REDUCER = 'page';
export const FORMS_REDUCER = 'forms';
export const FOOTER_REDUCER = 'footer';
export const POPUPS_REDUCER = 'popups';
export const DEVICE_REDUCER = 'device';
export const SESSION_REDUCER = 'session';
export const JACKPOTS_REDUCER = 'jackpots';
export const LIVE_GAMES_REDUCER = 'liveGames';
export const SPORTSBOOK_REDUCER = 'sportsbook';
export const PAGE_IN_POPUP_REDUCER = 'pageInPopup';
export const COOKIE_SETTINGS_REDUCER = 'cookieSettings';
export const MAINTENANCE_MODE_REDUCER = 'maintenanceMode';
export const MY_ACCOUNT_SIDEBAR_REDUCER = 'myAccountSidebar';
export const COMMUNICATION_WIDGETS_REDUCER = 'communicationWidgets';
